import { RefObject, useCallback, useRef, useState } from 'react';
import { EnhanceFormik } from './';

interface ExternalSubmitValue<T> {
  handleFormChanged: () => void;
  resetFormChanged: () => void;
  handleSubmit: () => void;
  formRef: RefObject<EnhanceFormik<T>>;
  hasFormChanged: boolean;
  showCancelButton: boolean;
}

export function useExternalSubmitButton<T = any>(): ExternalSubmitValue<T> {
  const [hasFormChanged, setFormChanged] = useState<boolean>(false);

  const formRef = useRef<EnhanceFormik<T>>(null);

  const handleFormChanged = useCallback(() => {
    setFormChanged(true);
  }, []);

  const resetFormChanged = useCallback(() => setFormChanged(false), []);

  const handleSubmit = useCallback(() => {
    if (formRef.current && formRef.current.form) {
      formRef.current.form.submitForm();
    } else {
      console.warn('No form ref to submit !');
    }
  }, []);

  return {
    handleFormChanged,
    resetFormChanged,
    handleSubmit,
    formRef,
    hasFormChanged,
    showCancelButton: hasFormChanged,
  };
}
